module.exports = __webpack_public_path__ + "static/01-f1da52e7b58fa809114237dc56f33ddb.png";